<template>
	<!-- 订单列表 -->
	<div class="order-list">
		<div class="tabs">
			<div class="tab tab2" :class="{active: selected == 1}" @click="onTabSelect(1)"><span>待处理</span></div>
			<div class="tab tab2" :class="{active: selected == 2}" @click="onTabSelect(2)"><span>已完成</span></div>
		</div>
		<!-- 待支付 -->
		<div class="content" v-show="selected == 1">
			<order-list url="/api/orders/my/pending" emptyTitle="暂无待处理订单" role='customer'></order-list>
		</div> 
		<!-- 已完成 -->
		<div class="content" v-show="selected == 2">
			<order-list url="/api/orders/my/finish" emptyTitle="暂无已完成订单" role="customer"></order-list>
		</div>
		<div id="jumpFormDiv" class="hidden"></div>
	</div>
</template>

<script>
import OrderList from '@/components/OrderList'
import { mapGetters } from 'vuex'

export default {
	name: 'MyOrderList',
	data: () => ({
		'selected': 1
	}),
	computed: {
		...mapGetters({
			selectedTab: 'getTab'
		})
	},
	components: {
		OrderList
	},
	mounted: function () {
		this.setPageTitle('我的订单')
		this.selected = this.selectedTab.index
		this.clearHistory()
	},
	methods: {
		clearHistory () {
			this.$store.dispatch('clearSelectedPayway', {})
			this.$store.dispatch('setTransList', { 'items': [] })
			this.$store.dispatch('setOrder', { 'order': {} })
			this.$store.dispatch('setPage', { 'showTransOps': false })
			this.rememberOrder('0', '')
		},
		onTabSelect (tabIndex) {
			this.selected = tabIndex
			this.$store.dispatch('setTab', tabIndex)
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// MyOrderList.vue?3f5b495a